import { Fragment, useState } from 'react';
import cx from 'classnames';
import { Student } from 'edrolo/types/ClassDetail';
import { Link } from 'react-router-dom';
import { utils as u } from 'edrolo-ui';
import urlResolver from 'edrolo/utils/URLResolver';
import { useAnalytics } from 'edrolo/analytics';

const COLLAPSED_NAME_LIMIT = 4;
const analyticsConstants = {
  events: {
    CLICKED_LINK_TO_STUDENT_COURSE_PROGRESS:
      'clicked link to student course progress',
    CLICKED_SIDEBAR_SCHOOL_CLASS_LINK: 'clicked sidebar school class link',
    CLICKED_TAKE_A_TOUR: 'clicked take a tour button',
    TOGGLED_STUDENT_NAMES: 'toggled student names',
  },
};
interface StudentNamesProps {
  students: Student[];
  classId: ClassId;
}

export const StudentNames = ({
  students,
  classId,
}: StudentNamesProps): JSX.Element | null => {
  const [expanded, setExpanded] = useState(false);

  const { track } = useAnalytics({});

  if (students.length === 0) {
    return null;
  }

  const studentsToShow = expanded
    ? students
    : students.slice(0, COLLAPSED_NAME_LIMIT);

  const sortedStudentsToShow = studentsToShow.sort((a, b) =>
    a.display_name.localeCompare(b.display_name)
  );

  const remainingCount = students.length - COLLAPSED_NAME_LIMIT;

  function handleLinkClick(student: Student) {
    track(analyticsConstants.events.CLICKED_LINK_TO_STUDENT_COURSE_PROGRESS, {
      student_user_id: student.user_id,
    });
  }

  function handleExpandClick() {
    track(analyticsConstants.events.TOGGLED_STUDENT_NAMES);

    setExpanded((prevExpanded) => !prevExpanded);
  }

  return (
    <div className={u.mt4} data-test="student-names">
      {sortedStudentsToShow.map((student, i) => (
        <Fragment key={student.profile_id}>
          {i > 0 ? ', ' : ''}
          <Link
            to={urlResolver.reverse('student-course-progress', {
              classId,
              profileId: student.profile_id,
            })}
            onClick={() => handleLinkClick(student)}
            className={cx(u.h5, u.link)}
          >
            <span data-mp-mask>{student.display_name}</span>
          </Link>
        </Fragment>
      ))}
      {!expanded && remainingCount > 0 && (
        <>
          {', and '}
          <button
            className={cx(u.h5, u.link)}
            onClick={() => handleExpandClick()}
          >
            {remainingCount === 1 ? '1 other' : `${remainingCount} others`}
          </button>
        </>
      )}
    </div>
  );
};
